import { Box, debounce, TextField } from '@mui/material'
import { Stack } from '@mui/system'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { Loader, NoListResult, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import { YardClerkViewStore } from '../../Stores/YardClerkViewStore'
import { YardClerkJourneyCard } from '../atoms/YardClerkJourneyCard'

type Props = {
  yardClerkViewStore: YardClerkViewStore
}

export const YardClerkJourneyList: FC<Props> = observer(({ yardClerkViewStore }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const [filteredText, setFilteredText] = useState<string>('')
  const { appViewStore } = usePlanningStore()

  const onChange = debounce(async (filter: string) => {
    setFilteredText(filter)
    yardClerkViewStore.searchContainerJourneys(filter)
  }, 300)

  const handleUpdatePosition = (journeyId: number) => {
    yardClerkViewStore.openDrawer(journeyId)
  }

  return (
    <>
      <Loader show={appViewStore.isLoading} />

      <Stack spacing={2}>
        <Box bgcolor={theme.palette.common.white} padding={theme.customSpacing.m}>
          <TextField
            fullWidth
            label={t('containerNo', 'Container No.')}
            placeholder={t('searchByContainerNumber', 'Search by container number')}
            onChange={e => onChange(e.target.value)}
          />
        </Box>

        <Box padding={theme.customSpacing.m}>
          <Stack spacing={2}>
            {yardClerkViewStore.filteredContainerJourneys.map(journey => (
              <YardClerkJourneyCard
                key={journey.id}
                containerJourneyId={journey.id}
                containerNumber={journey.containerNumber ?? ''}
                highlightText={filteredText}
                onUpdatePosition={handleUpdatePosition}
              />
            ))}
          </Stack>

          {yardClerkViewStore.filteredContainerJourneys.length === 0 &&
            filteredText.length > 0 &&
            !appViewStore.isLoading && (
              <NoListResult
                result={t('noContainerFound', 'No container found')}
                filtering={filteredText.length > 0}
              />
            )}
        </Box>
      </Stack>
    </>
  )
})
